/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Rights} from "./rights";

export const getCrmDefaultRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_SP_SALES,
    Rights.ROLE_SP_SALES_ADMIN,
    Rights.ROLE_SP_FINANCIAL
  ];
};
